<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Médias de cet article" />
            <ViewMediatheque />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ViewMediatheque from '../MediathequePoste/ViewMediatheque'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ViewMediathequePage',
    components: {
        NavBar,
        PageTitle,
        ViewMediatheque,
        FooterComp,
    }
}
</script>